import { render } from "./NavigationHeader.vue?vue&type=template&id=e83596d4"
const script = {}
script.render = render

export default script